export * from './datastore';
export var PlacementType;
(function (PlacementType) {
    PlacementType["Modal"] = "Modal";
    PlacementType["SectionScreen"] = "SectionScreen";
    PlacementType["SubsectionScreen"] = "SubsectionScreen";
    PlacementType["SubpageScreen"] = "SubpageScreen";
    PlacementType["Tile"] = "Tile";
    PlacementType["FullScreenSheet"] = "FullScreenSheet";
    PlacementType["BottomSheet"] = "BottomSheet";
    PlacementType["MaximizedScreen"] = "MaximizedScreen";
})(PlacementType || (PlacementType = {}));
export var Section;
(function (Section) {
    Section["Home"] = "ess-page-home";
    Section["Schedule"] = "schedule";
    Section["Pay"] = "ess-page-pay";
    Section["More"] = "more";
    Section["Job"] = "job";
})(Section || (Section = {}));
export { default as ModalId } from './ModalId';
export { default as TileId } from './TileId';
export { default as HeaderMenuItem } from './HeaderMenuItem';
export { default as HeaderFocusBehaviour } from './HeaderFocusBehaviour';
//# sourceMappingURL=index.js.map